module.exports = __webpack_public_path__ + "img/alfa_romeo.9b2f56ed.jpg";